var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "user__profile__modal" } }, [
    _c(
      "div",
      [
        _c("ValidationObserver", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var handleSubmit = ref.handleSubmit
                return [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return handleSubmit(_vm.saveUser)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.error,
                                  expression: "error"
                                }
                              ],
                              staticClass: "col-md-12 mb-3"
                            },
                            [
                              _c("div", { staticClass: "alert alert-danger" }, [
                                _vm._v(
                                  "Email address already in use. Please try a different email address."
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errorPw,
                                  expression: "errorPw"
                                }
                              ],
                              staticClass: "col-md-12 mb-3"
                            },
                            [
                              _c("div", {
                                staticClass: "alert alert-danger",
                                domProps: {
                                  innerHTML: _vm._s(_vm.errorMessage)
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("First Name")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.loggedInUserData.first_name,
                                    expression: "loggedInUserData.first_name"
                                  }
                                ],
                                ref: "focusThis",
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.loggedInUserData.first_name
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.loggedInUserData,
                                      "first_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Last Name")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.loggedInUserData.last_name,
                                    expression: "loggedInUserData.last_name"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.loggedInUserData.last_name
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.loggedInUserData,
                                      "last_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Email*")]),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  attrs: {
                                    mode: "passive",
                                    rules: "required|email"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.loggedInUserData.email,
                                                  expression:
                                                    "loggedInUserData.email"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                readonly:
                                                  _vm.loggedInUserData.id !=
                                                    "" &&
                                                  _vm.loggedInUserData.email !=
                                                    ""
                                              },
                                              domProps: {
                                                value:
                                                  _vm.loggedInUserData.email
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.loggedInUserData,
                                                    "email",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(errors, function(
                                              error,
                                              index
                                            ) {
                                              return _c(
                                                "span",
                                                {
                                                  key: index,
                                                  staticClass: "text-danger"
                                                },
                                                [_vm._v(_vm._s(error))]
                                              )
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "a",
                                {
                                  class: _vm.psExpanded ? "bordered-link" : "",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.toggleRows.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " Set New Password\n                          "
                                    ),
                                    _vm.psExpanded
                                      ? _c("i", {
                                          staticClass: "fas fa-chevron-up"
                                        })
                                      : _c("i", {
                                          staticClass: "fas fa-chevron-down"
                                        })
                                  ])
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            _vm.psExpanded
                              ? _c("div", { staticClass: "row m-0" }, [
                                  _c("div", { staticClass: "col-md-12 " }, [
                                    _c(
                                      "div",
                                      { staticClass: "row bordered-parent" },
                                      [
                                        _vm.psExpanded &&
                                        _vm.loggedInUserCompare
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 pr-0 pl-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-group" },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        "Current Password*"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        mode: "passive",
                                                        rules:
                                                          _vm.password != ""
                                                            ? "required"
                                                            : ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                (_vm.showCurrentPassword
                                                                  ? "text"
                                                                  : "password") ===
                                                                "checkbox"
                                                                  ? _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.currentPassword,
                                                                            expression:
                                                                              "currentPassword"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          type:
                                                                            "checkbox"
                                                                        },
                                                                        domProps: {
                                                                          checked: Array.isArray(
                                                                            _vm.currentPassword
                                                                          )
                                                                            ? _vm._i(
                                                                                _vm.currentPassword,
                                                                                null
                                                                              ) >
                                                                              -1
                                                                            : _vm.currentPassword
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            var $$a =
                                                                                _vm.currentPassword,
                                                                              $$el =
                                                                                $event.target,
                                                                              $$c = $$el.checked
                                                                                ? true
                                                                                : false
                                                                            if (
                                                                              Array.isArray(
                                                                                $$a
                                                                              )
                                                                            ) {
                                                                              var $$v = null,
                                                                                $$i = _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                              if (
                                                                                $$el.checked
                                                                              ) {
                                                                                $$i <
                                                                                  0 &&
                                                                                  (_vm.currentPassword = $$a.concat(
                                                                                    [
                                                                                      $$v
                                                                                    ]
                                                                                  ))
                                                                              } else {
                                                                                $$i >
                                                                                  -1 &&
                                                                                  (_vm.currentPassword = $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                              }
                                                                            } else {
                                                                              _vm.currentPassword = $$c
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  : (_vm.showCurrentPassword
                                                                      ? "text"
                                                                      : "password") ===
                                                                    "radio"
                                                                  ? _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.currentPassword,
                                                                            expression:
                                                                              "currentPassword"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          type:
                                                                            "radio"
                                                                        },
                                                                        domProps: {
                                                                          checked: _vm._q(
                                                                            _vm.currentPassword,
                                                                            null
                                                                          )
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.currentPassword = null
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.currentPassword,
                                                                            expression:
                                                                              "currentPassword"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          type: _vm.showCurrentPassword
                                                                            ? "text"
                                                                            : "password"
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            _vm.currentPassword
                                                                        },
                                                                        on: {
                                                                          input: function(
                                                                            $event
                                                                          ) {
                                                                            if (
                                                                              $event
                                                                                .target
                                                                                .composing
                                                                            ) {
                                                                              return
                                                                            }
                                                                            _vm.currentPassword =
                                                                              $event.target.value
                                                                          }
                                                                        }
                                                                      }
                                                                    ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "toggle-password top-55",
                                                                    on: {
                                                                      click:
                                                                        _vm.toggleCurrentPassword
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm.showCurrentPassword
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-eye"
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-eye-slash"
                                                                          }
                                                                        )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  errors,
                                                                  function(
                                                                    error,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "text-danger"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.psExpanded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 pr-0 pl-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-group" },
                                                  [
                                                    _c("label", [
                                                      _vm._v("New Password*")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        mode: "passive",
                                                        rules: !_vm
                                                          .loggedInUserData.id
                                                          ? "required"
                                                          : ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                (_vm.showPassword
                                                                  ? "text"
                                                                  : "password") ===
                                                                "checkbox"
                                                                  ? _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.password,
                                                                            expression:
                                                                              "password"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          type:
                                                                            "checkbox"
                                                                        },
                                                                        domProps: {
                                                                          checked: Array.isArray(
                                                                            _vm.password
                                                                          )
                                                                            ? _vm._i(
                                                                                _vm.password,
                                                                                null
                                                                              ) >
                                                                              -1
                                                                            : _vm.password
                                                                        },
                                                                        on: {
                                                                          input: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.validatePassword(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          },
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            var $$a =
                                                                                _vm.password,
                                                                              $$el =
                                                                                $event.target,
                                                                              $$c = $$el.checked
                                                                                ? true
                                                                                : false
                                                                            if (
                                                                              Array.isArray(
                                                                                $$a
                                                                              )
                                                                            ) {
                                                                              var $$v = null,
                                                                                $$i = _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                              if (
                                                                                $$el.checked
                                                                              ) {
                                                                                $$i <
                                                                                  0 &&
                                                                                  (_vm.password = $$a.concat(
                                                                                    [
                                                                                      $$v
                                                                                    ]
                                                                                  ))
                                                                              } else {
                                                                                $$i >
                                                                                  -1 &&
                                                                                  (_vm.password = $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                              }
                                                                            } else {
                                                                              _vm.password = $$c
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  : (_vm.showPassword
                                                                      ? "text"
                                                                      : "password") ===
                                                                    "radio"
                                                                  ? _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.password,
                                                                            expression:
                                                                              "password"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          type:
                                                                            "radio"
                                                                        },
                                                                        domProps: {
                                                                          checked: _vm._q(
                                                                            _vm.password,
                                                                            null
                                                                          )
                                                                        },
                                                                        on: {
                                                                          input: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.validatePassword(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          },
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.password = null
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.password,
                                                                            expression:
                                                                              "password"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          type: _vm.showPassword
                                                                            ? "text"
                                                                            : "password"
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            _vm.password
                                                                        },
                                                                        on: {
                                                                          input: [
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              ) {
                                                                                return
                                                                              }
                                                                              _vm.password =
                                                                                $event.target.value
                                                                            },
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.validatePassword(
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "toggle-password top-50",
                                                                    on: {
                                                                      click:
                                                                        _vm.togglePassword
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm.showPassword
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-eye"
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-eye-slash"
                                                                          }
                                                                        )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("password", {
                                                                  staticStyle: {
                                                                    "max-width":
                                                                      "unset",
                                                                    margin: "0"
                                                                  },
                                                                  attrs: {
                                                                    "strength-meter-only": true
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.password,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.password = $$v
                                                                    },
                                                                    expression:
                                                                      "password"
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  errors,
                                                                  function(
                                                                    error,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "text-danger"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.psExpanded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 pr-0 pl-0"
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "password-checklist"
                                                  },
                                                  [
                                                    _c(
                                                      "li",
                                                      {
                                                        class: {
                                                          "pw-list-item": true,
                                                          pass:
                                                            _vm.checkPwConditionReached(
                                                              "min"
                                                            ) == "pass",
                                                          error:
                                                            _vm.checkPwConditionReached(
                                                              "min"
                                                            ) == "err"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pw-list-check"
                                                          },
                                                          [
                                                            _c("i", {
                                                              class:
                                                                "fas " +
                                                                _vm.getPwListIcon(
                                                                  "min"
                                                                )
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " At least 8 letters\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        class: {
                                                          "pw-list-item": true,
                                                          pass:
                                                            _vm.checkPwConditionReached(
                                                              "uppercase"
                                                            ) == "pass",
                                                          error:
                                                            _vm.checkPwConditionReached(
                                                              "uppercase"
                                                            ) == "err"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pw-list-check"
                                                          },
                                                          [
                                                            _c("i", {
                                                              class:
                                                                "fas " +
                                                                _vm.getPwListIcon(
                                                                  "uppercase"
                                                                )
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " At least 1 capital letters\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        class: {
                                                          "pw-list-item": true,
                                                          pass:
                                                            _vm.checkPwConditionReached(
                                                              "lowercase"
                                                            ) == "pass",
                                                          error:
                                                            _vm.checkPwConditionReached(
                                                              "lowercase"
                                                            ) == "err"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pw-list-check"
                                                          },
                                                          [
                                                            _c("i", {
                                                              class:
                                                                "fas " +
                                                                _vm.getPwListIcon(
                                                                  "lowercase"
                                                                )
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " At least 1 lower case letters\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        class: {
                                                          "pw-list-item": true,
                                                          pass:
                                                            _vm.checkPwConditionReached(
                                                              "symbols"
                                                            ) == "pass",
                                                          error:
                                                            _vm.checkPwConditionReached(
                                                              "symbols"
                                                            ) == "err"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pw-list-check"
                                                          },
                                                          [
                                                            _c("i", {
                                                              class:
                                                                "fas " +
                                                                _vm.getPwListIcon(
                                                                  "symbols"
                                                                )
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " At least 1 special characters (!$#@%^*&{}[]<>)\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        class: {
                                                          "pw-list-item": true,
                                                          pass:
                                                            _vm.checkPwConditionReached(
                                                              "digits"
                                                            ) == "pass",
                                                          error:
                                                            _vm.checkPwConditionReached(
                                                              "digits"
                                                            ) == "err"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pw-list-check"
                                                          },
                                                          [
                                                            _c("i", {
                                                              class:
                                                                "fas " +
                                                                _vm.getPwListIcon(
                                                                  "digits"
                                                                )
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " At least 1 numberic digits\n                              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Roles*")]),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  attrs: { mode: "passive", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("multiselect", {
                                              attrs: {
                                                "show-labels": false,
                                                "track-by": "id",
                                                label: "name",
                                                options: _vm.allRoles,
                                                multiple: true,
                                                disabled:
                                                  _vm.loggedInUserCompare
                                              },
                                              model: {
                                                value:
                                                  _vm.loggedInUserData
                                                    .userRoles,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.loggedInUserData,
                                                    "userRoles",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "loggedInUserData.userRoles"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group user--preferences--multiselect"
                              },
                              [
                                _c("label", [_vm._v("Preferences")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.editing,
                                            expression: "!editing"
                                          }
                                        ],
                                        on: { click: _vm.showEditPreference }
                                      },
                                      [
                                        !_vm.preferenceData.deliverable_type ||
                                        !_vm.preferenceData.deliverable_type
                                          .length
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "exclude-outside-click cursor-pointer"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                          Click to set deliverable type preference\n                                      "
                                                )
                                              ]
                                            )
                                          : _vm._l(
                                              _vm.preferenceData
                                                .deliverable_type,
                                              function(preference, index) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key:
                                                      "user__preference__" +
                                                      index +
                                                      "__" +
                                                      Math.random(),
                                                    staticClass:
                                                      "exclude-outside-click badge badge-gray cursor-pointer"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                          " +
                                                        _vm._s(
                                                          preference.name
                                                        ) +
                                                        "\n                                      "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("multiselect", {
                                      directives: [
                                        {
                                          name: "click-outside",
                                          rawName: "v-click-outside",
                                          value: _vm.outside,
                                          expression: "outside"
                                        },
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.editing,
                                          expression: "editing"
                                        }
                                      ],
                                      ref: "userDeliverableType",
                                      attrs: {
                                        "show-labels": false,
                                        options: _vm.preferenceDeliverableTypes,
                                        multiple: true,
                                        label: "name",
                                        "track-by": "id"
                                      },
                                      model: {
                                        value:
                                          _vm.preferenceData.deliverable_type,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.preferenceData,
                                            "deliverable_type",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "preferenceData.deliverable_type"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.enablePasswordEdit && !_vm.loggedInUserCompare
                            ? _c("div", { staticClass: "col-md-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    [
                                      _vm._v("Active: "),
                                      _c("switches", {
                                        attrs: {
                                          theme: "bootstrap",
                                          color: "primary"
                                        },
                                        model: {
                                          value:
                                            _vm.loggedInUserData.is_enabled,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.loggedInUserData,
                                              "is_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "loggedInUserData.is_enabled"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex update-profile-controls" },
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "submit",
                                        "data-dismiss": "modal"
                                      }
                                    },
                                    [_vm._v("Save")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: _vm.toggleEnablePasswordEdit
                                      }
                                    },
                                    [
                                      _vm.enablePasswordEdit
                                        ? _c("span", [
                                            _vm._v("Back to profile")
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }